import { render, staticRenderFns } from "./tipsWindow.vue?vue&type=template&id=436c3b58&scoped=true"
import script from "./tipsWindow.vue?vue&type=script&lang=js"
export * from "./tipsWindow.vue?vue&type=script&lang=js"
import style0 from "./tipsWindow.vue?vue&type=style&index=0&id=436c3b58&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c3b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-hmt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436c3b58')) {
      api.createRecord('436c3b58', component.options)
    } else {
      api.reload('436c3b58', component.options)
    }
    module.hot.accept("./tipsWindow.vue?vue&type=template&id=436c3b58&scoped=true", function () {
      api.rerender('436c3b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tipsWindow.vue"
export default component.exports